import {
    SET_ASSET_ITEM_STATUS_PURCHASE_ORDER,
    SET_IS_ASSET_ITEM_STATUS_PURCHASE_ORDER_CALLED
} from "./AssetItemStatusPurchaseOrderType"

const initialState = {
    assetItemStatusPurchaseOrder: [],
    loadingStates: {} as any 
}


const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_ASSET_ITEM_STATUS_PURCHASE_ORDER:
            return {
                ...state,
                assetItemStatusPurchaseOrder: action.assetItemStatusPurchaseOrder
            };
        case SET_IS_ASSET_ITEM_STATUS_PURCHASE_ORDER_CALLED:
            const { fleetDetailId, isLoading } = action;
            return {
              ...state,
              loadingStates: {
                ...state.loadingStates,
                [fleetDetailId]: {
                  ...state.loadingStates[fleetDetailId],
                  isLoading: isLoading
                }
              }
            };
        default:
            return state;
    }
};

export default reducer;